import {
  IconButton, Dialog, DialogTitle, DialogContent, Grid, Switch, FormControl,
  FormControlLabel, DialogActions, Container, Card, Divider, CardContent, TextField,
  MenuItem, createMuiTheme, CircularProgress,
  Backdrop,
  Snackbar
} from '@material-ui/core';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import DateFnsUtils from '@date-io/date-fns';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import CloseIcon from '@material-ui/icons/Close';
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';


import moment from 'moment';
import { useHistory } from 'react-router';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getTasksRequest } from 'src/store/actions';
import trLocale from 'date-fns/locale/tr';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import Alert from 'src/components/Alert';
import RetailerSearch from './Selects/RetailerSearch';
import AppReasonSearch from './Selects/AppReasonSearch';
import ProductWorkCaseSearch from './Selects/ProductWorkCaseSearch';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

const useStyles = makeStyles((theme) => ({
  rootNewWorkCasePopup: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actionsNewWorkCase: {
    justifyContent: 'flex-end'
  },
  radioGroup: {
    justifyContent: 'space-around'
  },
}));

const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

const localeMap = {
  tr: trLocale
};


function NewWorkCasePopup({
  open, onClose, ConsumerId, ReceiptNo, className
}) {


  var Today = new Date;


  const DefaultWorkCase = {
    ConsumerId: 0,
    ProductId: 0,
    Product: '',
    OnSiteOperation: 1,
    WarrantyTypeId: 1,
    IssueId: 1,
    Issue: '',
    RetailerId: 0,
    Retailer: '',
    StatusId: 1,
    Comment: '',
    WarrantyDate: null,
    AppointmentDate: null,
  };


  const DefaultConsumerValue = {
    SearchId: 0,
    Search: '',
    LanguageCode: '',
    EmployeeId: '',
    Phones: [],
    Addresses: [
      {
        AddressType: '',
        Address: '',
        State: '',
        AddressItem: '',
        Apartment: '',
        City: '',
        Country: '',
        District: '',
        DoorNr: '',
        Latitude: 0,
        Longitude: 0,
        Neighborhood: '',
        PostCode: '',
        Region: '',
        Street: '',
        PrimaryAddress: true,
        AddressTypeId: 1,
        AddressId: 0
      }
    ],
    Title: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Email: '',
    Active: true,
    ConsumerId: 0,
    CustomerTypeId: 1,
    InsurancePlanNumber: '',
    ReferralNumber: '',
    WorkCaseCount: 0,
    AssetCount: 0
  };

  const SessionUser = getUser();
  const locale = localStorage.getItem('i18nextLng');
  const [ResponseDsc, setResponseDsc] = useState('');
  const [uyari, setUyari] = React.useState(false);
  const { t } = useTranslation('work_order');
  const [uyariTip, setUyariTip] = React.useState();
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [NewWorkCaseData, setNewWorkCaseData] = useState(DefaultWorkCase);
  const [formData, setFormdata] = useState(DefaultConsumerValue);
  const [NewWorkCasePopup, setNewWorkCasePopup] = useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseType, setResponseType] = useState('success');
  const [warrantyDateDisable, setWarrantyDateDisable] = useState(false);
  const [selectedWarrantyType, setSelectedWarrantyType] = useState([]);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  const [Assets, setAssets] = useState([]);
  const [newAssetChosen, setNewAssetChosen] = useState(false);
  const [assetChosen, setAssetChosen] = useState(false);
  const search = '';
  const [PlaceData, setPlaceData] = useState([]);
  const [AssignTo, setAssignTo] = useState("3")
  const [WarrantyData, setWarrantyData] = useState([]);
  const [Required, setRequired] = React.useState(false);
  const [loading2, setLoading2] = useState(false);
  const [NewAppointment, setNewAppointment] = useState(null);
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const SaveWorkCase = () => {
    if (!ConsumerId) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      setRequired(true);
      return;
    }

    if (
      NewWorkCaseData.ProductId === 0
      || NewWorkCaseData.ProductId === undefined
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    if (
      NewWorkCaseData.ProductId === 0
      || NewWorkCaseData.ProductId === undefined
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    if (
      NewWorkCaseData.IssueId === 0
      || NewWorkCaseData.IssueId === undefined
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    const dataBody = { ...NewWorkCaseData };
    dataBody.EmployeeId = SessionUser.TechnicianId;
    dataBody.ConsumerId = ConsumerId;
    dataBody.Source = AssignTo;


    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetWorkCase', dataBody, dataConfig)
      .then((response) => {
        const ResponseData = response.data[0];
        if (parseInt(ResponseData.ErrorCode) === 0) {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('success');
          setUyari(true);
          setNewWorkCaseData(DefaultWorkCase);
          onClose();
        } else {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        }
      })
      .catch((error) => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });
  };

  const GetConsumerAssetsData = () => {
    setLoading2(true);
    axios
      .get(`/GetConsumerAssets/${ConsumerId}`)
      .then((response) => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setAssets([]);
        } else {
          setAssets(ResponseData);
        }
        setLoading2(false);
      })
      .catch((error) => {
        setLoading2(false);
      });
  };

  const handleChangeWarrantyTypeId = e => {
    let data = e.target.value;
    var WarrantyGroupId = WarrantyData.filter(x => x.WarrantyId === data);
    if (WarrantyGroupId[0].WarrantyGroupId === 6) {
      const today = moment(new Date()).format('YYYY-MM-DD');
      setWarrantyDateDisable(true);
      setNewWorkCaseData({
        ...NewWorkCaseData,
        WarrantyTypeId: data,
        WarrantyDate: today
      });
    } else {
      setWarrantyDateDisable(false);
      setNewWorkCaseData({
        ...NewWorkCaseData,
        WarrantyTypeId: data
      });
    }




    setSelectedWarrantyType(data);
  };


  const setNewWorkCaseAssets = item => {
    if (item != null) {
      setAssetChosen(true);

      setLoading2(true);

      axios
        .get(
          '/GetAssetWarrantyDate/' +
          item.ProductId +
          '/' +
          item.ProductionYear +
          '/' +
          item.ProductionMonth +
          '/' +
          item.SerialNr +
          '/' +
          item.WarrantyId
        )
        .then(response => {
          setNewWorkCaseData({
            ...NewWorkCaseData,
            ProductId: item.ProductId,
            WarrantyDate: response.data != null && response.data != "" && response.data != undefined 
                          ? moment(response.data).format('YYYY.MM.DD') 
                          : moment(item.WarrantyDate).format('YYYY.MM.DD'),
            ProductionYear: item.ProductionYear,
            ProductionMonth: item.ProductionMonth,
            SerialNr: item.SerialNr,
          });

          setWarrantyDateDisable(true);

          setLoading2(false);
        })
        .catch(error => {
          setLoading2(false);
        });
    } else {
      setWarrantyDateDisable(false);
      setAssetChosen(false);
    }
  };
  const setProduct = (param) => {
    const Data = { ...NewWorkCaseData };
    Data.Product = param.Dsc;
    Data.ProductId = param.Id;
    setNewWorkCaseData(Data);
    setNewAssetChosen(param.Id > 0);
  };

  const setIssue = (param) => {
    const Data = { ...NewWorkCaseData };
    Data.Issue = param.Dsc;
    Data.IssueId = param.Id;
    setNewWorkCaseData(Data);
  };

  const setRetailer = (param) => {
    const Data = { ...NewWorkCaseData };
    Data.Retailer = param.Dsc;
    Data.RetailerId = param.Id;
    setNewWorkCaseData(Data);
  };

  const GetPlace = () => {
    axios
      .get('/GetPlace')
      .then((response) => {
        if (response.data.length > 0) {
          setPlaceData(response.data);
        }
      })
      .catch((error) => { });
  };

  const GetWarranty = () => {
    axios
      .get('/GetSiriusWarrantyType')
      .then((response) => {
        if (response.data.length > 0) {
          setWarrantyData(response.data);
        }
      })
      .catch((error) => { });
  };

  useEffect(() => {
    GetConsumerAssetsData();
    GetWarranty();
    GetPlace();
  }, [ReceiptNo, ConsumerId]);

  const SetWarrantyDate = (value) => {
    const DateValue = moment(value).format('YYYY-MM-DD');
    setNewWorkCaseData({ ...NewWorkCaseData, WarrantyDate: value });
  };

  const setAppointmentData = (value) => {
    setNewAppointment(value);
    const DateValue = moment(value).format('YYYY-MM-DD HH:mm');



    setNewWorkCaseData({ ...NewWorkCaseData, AppointmentDate: DateValue });
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xl"
      fullScreen
      onClose={() => { onClose(); }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert
          onClose={uyariKapat}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>
      <Backdrop className={classes.backdrop} open={loading || loading2}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DialogTitle id="alert-dialog-title">{t('lblNewWorkCase')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} lg={12}>
            <TextField
              size="small"
              fullWidth
              select
              label={t('lblStatus')}
              id="StatusId"
              value={NewWorkCaseData ? NewWorkCaseData.StatusId : 1}
              onChange={(event) => setNewWorkCaseData({
                ...NewWorkCaseData,
                StatusId: event.target.value
              })}
              variant="outlined"
            >
              <MenuItem key={1} value={1}>
                {t('lblOpen')}
              </MenuItem>
              {/* <MenuItem key={2} value={2}>
                          {t('lblClose')}
                        </MenuItem> */}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <Autocomplete
              id="ProductId"
              options={Assets}
              size="small"
              getOptionLabel={(p) => (p.ProductId ? (
                `${p.ProductCode
                }-${p.Product
                }-${p.ProductionYear
                }-${p.ProductionMonth
                }-${p.SerialNr
                }-${p.Warranty
                }-${p.WarrantyDate
                }-${p.Brand}`
              ) : '')}
              renderOption={(p) => (
                <MenuItem value={p.ProductId}>
                  {p.ProductCode}
                  <br />
                  {p.Product}
                  <br />
                  {p.ProductionYear + '-' + p.ProductionMonth + '-' + p.SerialNr}
                  <br />
                  {p.Warranty + '-' + p.WarrantyDate + '-' + p.SerialNr}
                  <br />
                  {p.Brand}
                </MenuItem>
              )}
              renderInput={(params) => <TextField {...params} label={t('lblAsset')} variant="outlined" />}
              defaultValue={NewWorkCaseData ? NewWorkCaseData.ProductId : ''}
              onChange={(event, value) => {
                setNewWorkCaseAssets(value);
              }}
              disabled={newAssetChosen}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <ProductWorkCaseSearch
              setProduct={setProduct}
              value={
                {
                  Dsc: NewWorkCaseData.Product || '',
                  Id: NewWorkCaseData.ProductId || 0
                } || ''
              }
              disabled={assetChosen}
              searchParam={search}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <AppReasonSearch
              setIssue={setIssue}
              value={
                {
                  Dsc: NewWorkCaseData.Issue || '',
                  Id: NewWorkCaseData.IssueId || 0
                } || ''
              }
              searchParam={search}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <RetailerSearch
              setRetailer={setRetailer}
              value={
                {
                  Dsc: NewWorkCaseData.Retailer || '',
                  Id: NewWorkCaseData.RetailerId || 0
                } || ''
              }
              searchParam={search}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <TextField
              size="small"
              fullWidth
              select
              id="WarrantyTypeId"
              label={t('lblOnSiteOperation')}
              value={
                NewWorkCaseData ? NewWorkCaseData.OnSiteOperation : ''
              }
              onChange={(event) => setNewWorkCaseData({
                ...NewWorkCaseData,
                OnSiteOperation: event.target.value
              })}
              variant="outlined"
            >
              {PlaceData.map((p) => (
                <MenuItem key={p.Id} value={p.Id}>
                  {p.Dsc}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <TextField
              size="small"
              fullWidth
              select
              id="WarrantyTypeId"
              label={t('lblWarranty')}
              value={
                NewWorkCaseData ? NewWorkCaseData.WarrantyTypeId : ''
              }
              onChange={event => {
                handleChangeWarrantyTypeId(event);
              }}
              variant="outlined"
            >
              {WarrantyData.map((p) => (
                <MenuItem key={p.WarrantyId} value={p.WarrantyId}>
                  {p.FieldText}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap[locale]}
              >
                <KeyboardDatePicker
                  color="primary"
                  fullWidth
                  size="small"
                  inputVariant="outlined"
                  id="WarrantyDate"
                  label={t('lblWarrantyDate')}
                  disabled={warrantyDateDisable || assetChosen}
                  invalidDateMessage={t('hatali_tarih')}
                  format="dd.MM.yyyy"
                  variant="outlined"
                  value={
                    NewWorkCaseData
                      ? NewWorkCaseData.WarrantyDate
                      : ''
                  }
                  onChange={e => SetWarrantyDate(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap[locale]}
              >
                <KeyboardDateTimePicker
                  color="primary"
                  fullWidth
                  size="small"
                  ampm={false}
                  inputVariant="outlined"
                  id="WarrantyDate"
                  label={t('lblAppointmentDate')}
                  invalidDateMessage={t('hatali_tarih')}
                  format="dd.MM.yyyy HH.mm"
                  variant="outlined"
                  value={NewAppointment}
                  onChange={(e) => setAppointmentData(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <TextField
              size="small"
              label={t('lblNote')}
              name="Comment"
              multiline
              rows={6}
              fullWidth
              value={NewWorkCaseData.Comment ? NewWorkCaseData.Comment : ''}
              onChange={(event) => setNewWorkCaseData({
                ...NewWorkCaseData,
                Comment: event.target.value
              })}
              variant="outlined"
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <RadioGroup row value={AssignTo} onChange={(event) => { setAssignTo(event.target.value);  }} className={classes.radioGroup}>
            <FormControlLabel value="3" control={<Radio />} label={t('lblAssignToService')} />
            <FormControlLabel value={"2"} control={<Radio />} label={t('lblAssignToMe')} />
          </RadioGroup>
        </Grid>
      </DialogContent>
      <DialogActions>
        <IconButton
          color="primary"
          onClick={() => SaveWorkCase()}
          aria-label="save"
          component="span"
        >
          <SaveOutlinedIcon />
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => { onClose(); }}
          aria-label="upload picture"
          component="span"
        >
          <CloseIcon />
        </IconButton>
      </DialogActions>
    </Dialog>
  );
}

NewWorkCasePopup.defaultProps = {
  open: false,
  onClose: () => { },
};

export default NewWorkCasePopup;
